/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Pre_Render_Frame_Cache_Failed_StatusInputs */

const en_pre_render_frame_cache_failed_status = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cannot generate frame cache: ${i?.error}`)
};

const fr_pre_render_frame_cache_failed_status = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossible de générer le cache d'images : ${i?.error}`)
};

const de_pre_render_frame_cache_failed_status = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Frame-Cache konnte nicht generiert werden: ${i?.error}`)
};

const it_pre_render_frame_cache_failed_status = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile generare la cache dei frame: ${i?.error}`)
};

const ru_pre_render_frame_cache_failed_status = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось создать кэш кадров: ${i?.error}`)
};

const es_pre_render_frame_cache_failed_status = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se puede generar la caché de fotogramas: ${i?.error}`)
};

const zh_cn2_pre_render_frame_cache_failed_status = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法生成帧缓存：${i?.error}`)
};

const ja_pre_render_frame_cache_failed_status = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フレームキャッシュを生成できません: ${i?.error}`)
};

const hi_pre_render_frame_cache_failed_status = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`फ्रेम कैश उत्पन्न नहीं किया जा सकता: ${i?.error}`)
};

const pt_pt2_pre_render_frame_cache_failed_status = /** @type {(inputs: Pre_Render_Frame_Cache_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível gerar o cache de quadros: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Cannot generate frame cache: {error}" |
*
* @param {Pre_Render_Frame_Cache_Failed_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_failed_status = /** @type {((inputs: Pre_Render_Frame_Cache_Failed_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Failed_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_pre_render_frame_cache_failed_status(inputs)
	if (locale === "de") return de_pre_render_frame_cache_failed_status(inputs)
	if (locale === "it") return it_pre_render_frame_cache_failed_status(inputs)
	if (locale === "ru") return ru_pre_render_frame_cache_failed_status(inputs)
	if (locale === "es") return es_pre_render_frame_cache_failed_status(inputs)
	if (locale === "zh-CN") return zh_cn2_pre_render_frame_cache_failed_status(inputs)
	if (locale === "ja") return ja_pre_render_frame_cache_failed_status(inputs)
	if (locale === "hi") return hi_pre_render_frame_cache_failed_status(inputs)
	if (locale === "pt-PT") return pt_pt2_pre_render_frame_cache_failed_status(inputs)
	return en_pre_render_frame_cache_failed_status(inputs)
});